// extracted by mini-css-extract-plugin
export default {"licenseContainer":"licensePage_licenseContainer__deTKC","title":"licensePage_title__aN+55","workRightManual_countRows":"licensePage_workRightManual_countRows__DLdZv"};